import ObservabilityMetadata from './ObservabilityMetadata';

// client side there is only a single instance of the class
const instance = new ObservabilityMetadata();

export default instance;
